import styled, { css } from 'styled-components';
import { darken } from 'polished';
import { colors } from '@/theme/colors';

const buttonDarkStyles = css`
  border: 1px solid ${({ theme }) => theme.yellowDark};
  color: ${({ theme }) => theme.yellowDark};

  &:not(:disabled):hover {
    background: ${({ theme }) => darken(0.3, theme.yellowDark)};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => darken(0.3, theme.yellowDark)};
  }
`;

export const Container = styled.div`
  color: ${({ theme }) => theme.text};

  .pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.5rem;

    user-select: none;

    .show-count {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
    }

    .button-group {
      display: flex;
      align-items: center;
      gap: 10px;

      button {
        width: 36px;
        height: 36px;
        border: 1px solid ${colors.ciano700};
        background: transparent;
        border-radius: 4px;
        color: ${colors.ciano700};

        display: flex;
        align-items: center;
        padding: 10px;
        transition: background 0.2s;

        &:not(:disabled):hover {
          background: #969CA4;
        }

        &:disabled {
          cursor: not-allowed;
          color: #cbd5e1;
          border: 1px solid #cbd5e1;
        }

        ${({ theme }) => theme.darkMode && buttonDarkStyles}
      }
    }
  }
`;

export const Box = styled.div`
  border-bottom: 1px solid #f1f5f9;
  padding: 1rem 0;
  padding-bottom: 0rem;

  .box-city,
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .percent {
      min-width: 80px;
      text-align: right;
    }
  }

  .box-title {
    p {
      font-weight: 700;
    }
  }
`;
